import { useMemo } from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Box, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';

import Button from '@/components/Buttons/Button';
import {
  ExpiredBannerType,
  useExpiredBannerContent
} from '@/components/ExpiredBanner/hooks/useExpiredBannerContent';
import UpgradeToPremiumButton from '@/components/UpgradeToPremium/UpgradeToPremiumButton';
import useUserDetails from '@/hooks/useUserDetails';

import KeyDialog from './KeyDialog';
import ApiKeyTable from './Table';
import useTokenGeneration from './useTokenGeneration';

const TokenGenerationComponent = () => {
  const { apiKeys, open, setOpen, error } = useTokenGeneration();
  const { isUserExpired, isUserPremium } = useUserDetails();
  const expiredBannerContent = useExpiredBannerContent();
  const isFeatureBlocked = isUserExpired || !isUserPremium;

  const upgradeButtonType = useMemo(() => {
    if (isUserExpired || expiredBannerContent?.type === ExpiredBannerType.trialEndingSoon) {
      return 'expired';
    }

    return 'upgrade';
  }, [expiredBannerContent?.type, isUserExpired]);

  return (
    <Box
      component={Paper}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 3,
        width: '100%'
      }}
    >
      <KeyDialog
        open={open}
        setOpen={setOpen}
      />
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Typography variant='h6'>Token Generation</Typography>
        <Button
          disabled={isFeatureBlocked}
          size='small'
          startIcon={<AddIcon />}
          variant='contained'
          onClick={() => {
            setOpen(!open);
          }}
        >
          Generate new token
        </Button>
      </Box>
      {isFeatureBlocked && (
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Typography sx={{ py: 3 }}>
            GX Go Premium users can export data through our API and many other methods.
          </Typography>
          <UpgradeToPremiumButton type={upgradeButtonType} />
        </Box>
      )}
      {!isFeatureBlocked && Boolean(error) && error}
      {!isFeatureBlocked && !error && <ApiKeyTable apiKeys={apiKeys} />}
    </Box>
  );
};

export default TokenGenerationComponent;
